import { SET_MESSAGE, CLEAR_MESSAGE } from "../types/message.types";

const initialState = {
	type: "",
	message: "",
};

export default function messageReducer(state = initialState, action) {
	switch (action.type) {
		case SET_MESSAGE:
			return {
				...state,
				type: action.payload.type,
				message: action.payload.message,
			};
		case CLEAR_MESSAGE:
			return {
				...state,
				type: "",
				message: "",
			};
		default:
			return state;
	}
}
